import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ajaxPost } from '../ajax'

function StripeM2Connect({stripe, location, initConnection}) {
  useEffect(() => {
    loadM2Terminal()
  }, [stripe.location])

  const fetchConnectionToken = async () => {
    const data = { location_id: location, stripe_location: stripe.location }
    const response = await ajaxPost('/admins/payment/create_connection', data)
    const json = await response.json()
    return json.secret
  }

  const loadM2Terminal = async () => {
    if (!stripe.location) return

    const connectionToken = await fetchConnectionToken()
    initConnection({ token: connectionToken, location: stripe.location, simulator: stripe.use_simulator })
  }

  return null
}

StripeM2Connect.propTypes = {
  stripe: PropTypes.object.isRequired,
  location: PropTypes.number,
}

export default StripeM2Connect

